import React from "react";
import {Toggle} from "@rescui/toggle";
import {LayoutControl, FontControl, IconControl} from "./Selectors";

type Props = {
  channel: string; layout: number; layouts: Array<{id: number; iconId: string | number}>; showLayout: boolean;
  onLayout: (value: number) => void; compact?: boolean;
  fontEnabled: boolean; onFontEnabled: (value: boolean) => void; font: string; onFont: (value: string) => void;
  typograf: boolean; onTypograf: (value: boolean) => void;
  logoHidden: boolean; onLogoHidden: (value: boolean) => void;
  uppercase: boolean; onUppercase: (value: boolean) => void;
  icon: string; iconAmount: number; onIcon: (value: string) => void;
};
export function AppearanceSections(p: Props) {
  return <>
    {(p.channel === "social" || p.channel === "email") && <div className="localization-wrap">
      <div className="localization"><span className="label">Localization</span>
        <Toggle aria-label="Localization" checked={p.fontEnabled} className="font-toggle" onChange={(e) => p.onFontEnabled(e.target.checked)} />
      </div>
      {p.fontEnabled && <FontControl value={p.font} onChange={p.onFont} />}
    </div>}
    <div className="localization-wrap"><div className="localization" data-tooltip="Auto-formats text: smart quotes, em dashes, non-breaking spaces, ellipsis">
      <span className="label">Typograf</span><Toggle aria-label="Typograf" checked={p.typograf} className="font-toggle" onChange={(e) => p.onTypograf(e.target.checked)} />
    </div></div>
    {p.channel === "social" && <div className="localization-wrap"><div className="localization">
      <span className="label">Logo</span><Toggle aria-label="Show logo" checked={!p.logoHidden} className="font-toggle" onChange={(e) => p.onLogoHidden(!e.target.checked)} />
    </div>{p.logoHidden && <div className="logo-hidden-warning">Warning: the logo is hidden on the banners. Please note that these banners can only be used on JetBrains social media accounts, where the logo is already in the profile picture.</div>}</div>}
    {p.showLayout && <LayoutControl channel={p.channel} value={p.layout} options={p.layouts} onChange={p.onLayout} compact={p.compact} />}
    {p.channel === "video" && <><span className="label">Uppercase</span><div className="layout-uppercase">
      <Toggle aria-label="Uppercase" checked={p.uppercase} className="uppercase-toggle" onChange={(e) => p.onUppercase(e.target.checked)} />
    </div></>}
    {p.channel === "social" && p.layout === 7 && <><span className="label">Icon</span><IconControl channel={p.channel} value={p.icon} amount={p.iconAmount} onChange={p.onIcon} /></>}
  </>;
}
